import { Stack, StackProps, styled } from '@mui/material';
import clsx from 'clsx';

import { CloseDrawerButton, CloseDrawerButtonProps } from './CloseDrawerButton';
import { drawerCssVars } from './cssVars';
import { mergeSx } from '../../utils';

const Header = styled(Stack)({
  paddingTop: 24,
  paddingBottom: 16,
  width: '100%',
  flexShrink: 0,
});

type DrawerHeaderProps = StackProps & {
  testId?: string;
  closeButtonProps?: CloseDrawerButtonProps;
};

export const DrawerHeader = ({
  testId,
  children,
  className,
  closeButtonProps,
  sx,
  ...props
}: DrawerHeaderProps) => {
  return (
    <Header
      component="header"
      direction="row"
      {...props}
      className={clsx('DS-Drawer-Header', className)}
      sx={mergeSx(
        {
          px: drawerCssVars.getters.horizontalPadding(),
        },
        sx
      )}
      data-testid={testId}
    >
      <CloseDrawerButton positioned="flex" {...closeButtonProps} />
      {children}
    </Header>
  );
};
